// extracted by mini-css-extract-plugin
export default {"cv_cont":"Cv_cv_cont__eoMRT","download_btn_cont":"Cv_download_btn_cont__9u6c4","download_icon":"Cv_download_icon__l8jLl"};